export default "Fonds de Décarbonation Industrie (France 2030) — Aide à la Transition Énergétique | Solution Éco France";
